export default __webpack_public_path__ + "static/media/arrow-left.2f30928e.svg";